import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { db, storage } from '../firebaseConfig';
// eslint-disable-next-line no-unused-vars
import { doc, getDoc, updateDoc, addDoc, collection, Timestamp, runTransaction } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../context/AuthContext';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoStar, IoStarOutline, IoCloudUploadOutline, IoImageOutline } from 'react-icons/io5';

const AVAILABLE_TAGS = [
  "Puntualidad",
  "Rapidez",
  "Amabilidad",
  "Limpieza",
  "Buen Precio",
  "Calidad",
  "Comunicación",
  "Profesionalismo"
];

function CalificarServicioScreen() {
  const navigate = useNavigate();
  const { cotizacionId } = useParams();
  const { currentUser } = useAuth();

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comentario, setComentario] = useState('');
  const [selectedTags, setSelectedTags] = useState([]); // Nuevos Tags
  const [archivos, setArchivos] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [cotizacion, setCotizacion] = useState(null);

  useEffect(() => {
    const fetchCotizacion = async () => {
      if (!cotizacionId) return;
      setLoading(true);
      try {
        const docRef = doc(db, "cotizaciones", cotizacionId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setCotizacion({ id: docSnap.id, ...docSnap.data() });
        } else {
          alert("Cotización no encontrada");
          navigate(-1);
        }
      } catch (error) {
        console.error("Error fetching cotizacion:", error);
      }
      setLoading(false);
    };
    fetchCotizacion();
  }, [cotizacionId, navigate]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setArchivos(files);
    const newPreviews = files
      .filter(file => file.type.startsWith('image/'))
      .map(file => URL.createObjectURL(file));
    setPreviews(newPreviews);
  };

  const toggleTag = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  // ... inside CalificarServicioScreen ...

  // Nuevos estados
  const [selectedEvidence, setSelectedEvidence] = useState([]); // URLs seleccionadas de la evidencia final

  // Privacy Helper
  const getPrivacyName = (fullName) => {
    if (!fullName) return "Residente";
    const parts = fullName.split(' ');
    // Ejemplo: Manuel Pérez -> Manuel P.
    if (parts.length > 1) {
      return `${parts[0]} ${parts[1][0]}.`;
    }
    return parts[0];
  };

  const handleEvidenceToggle = (url) => {
    if (selectedEvidence.includes(url)) {
      setSelectedEvidence(selectedEvidence.filter(u => u !== url));
    } else {
      setSelectedEvidence([...selectedEvidence, url]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert("Por favor selecciona una calificación.");
      return;
    }

    setEnviando(true);
    try {
      // 1. Subir fotos nuevas (si hay)
      const urlsNuevas = [];
      for (const file of archivos) {
        const storageRef = ref(storage, `resenas/${currentUser.uid}/${Date.now()}_${file.name}`);
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        urlsNuevas.push(url);
      }

      // Combinar fotos nuevas + seleccionadas
      const finalMediaUrls = [...selectedEvidence, ...urlsNuevas];

      // 2. Guardar Reseña y Actualizar Proveedor (Transacción)
      await runTransaction(db, async (transaction) => {
        // Leer proveedor actual para obtener rating actual
        const proveedorRef = doc(db, "market_proveedores", cotizacion.proveedorId);
        const proveedorDoc = await transaction.get(proveedorRef);

        if (!proveedorDoc.exists()) {
          throw new Error("Proveedor no existe");
        }

        const proveedorData = proveedorDoc.data();
        const nuevoTotal = (proveedorData.totalCalificaciones || 0) + 1;
        const nuevoPromedio = ((proveedorData.ratingPromedio || 0) * (proveedorData.totalCalificaciones || 0) + rating) / nuevoTotal;

        // Actualizar contadores de Tags
        const currentTagsCounts = proveedorData.tagsCounts || {};
        const newTagsCounts = { ...currentTagsCounts };
        selectedTags.forEach(tag => {
          newTagsCounts[tag] = (newTagsCounts[tag] || 0) + 1;
        });

        // Crear reseña
        const resenaRef = doc(collection(db, "market_resenas"));
        transaction.set(resenaRef, {
          proveedorId: cotizacion.proveedorId,
          residenteId: currentUser.uid,
          cotizacionId: cotizacionId,
          calificacion: rating,
          comentario: comentario,
          tags: selectedTags, // Guardamos tags en la reseña
          fotosUrls: finalMediaUrls,
          fecha: Timestamp.now(),
          nombreResidente: getPrivacyName(cotizacion.nombreResidente), // PRIVACY APPLIED
          condominio: "Condominio", // Generic or fetch from context if needed public
        });

        // Actualizar proveedor
        transaction.update(proveedorRef, {
          ratingPromedio: Number(nuevoPromedio.toFixed(1)),
          totalCalificaciones: nuevoTotal,
          tagsCounts: newTagsCounts
        });

        // Actualizar cotización a "completada" (asegurar flag)
        const cotizacionRef = doc(db, "cotizaciones", cotizacionId);
        transaction.update(cotizacionRef, {
          estatus: "completada",
          tieneResena: true
        });
      });

      alert("¡Gracias por tu reseña!");
      navigate('/marketplace/mis-cotizaciones');

    } catch (error) {
      console.error("Error al enviar reseña:", error);
      alert("Error al enviar la reseña. Inténtalo de nuevo.");
    } finally {
      setEnviando(false);
    }
  };

  if (loading || !cotizacion) return <div className="form-container"><p>Cargando...</p></div>;

  return (
    <div className="form-container" style={{ maxWidth: '600px' }}>
      <div className="form-header-container">
        <button onClick={() => navigate(-1)} className="form-back-button">
          <IoArrowBack />
        </button>
        <h1 className="form-header">Calificar Servicio</h1>
      </div>

      <div className="form-group-section" style={{ textAlign: 'center' }}>
        <h3>{cotizacion.nombreProveedor}</h3>
        <p>¿Cómo estuvo el servicio?</p>

        <div className="star-rating-input" style={{ fontSize: '3rem', margin: '20px 0', cursor: 'pointer' }}>
          {[...Array(5)].map((star, index) => {
            const ratingValue = index + 1;
            return (
              <span
                key={index}
                onClick={() => setRating(ratingValue)}
                onMouseEnter={() => setHover(ratingValue)}
                onMouseLeave={() => setHover(0)}
                style={{ color: ratingValue <= (hover || rating) ? "#ffc107" : "#e4e5e9" }}
              >
                <IoStar />
              </span>
            );
          })}
        </div>
      </div>

      {/* EVIDENCE SELECTION SECTION */}
      {cotizacion.evidenciaFinalUrls && cotizacion.evidenciaFinalUrls.length > 0 && (
        <div className="form-group-section">
          <h4 style={{ marginBottom: 10, color: '#4b5563' }}>Evidencia del Trabajo Final</h4>
          <p style={{ fontSize: '0.9rem', color: '#6b7280', margin: '0 0 15px' }}>Selecciona las fotos que deseas incluir en tu reseña pública.</p>

          <div className="gallery-container" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
            {cotizacion.evidenciaFinalUrls.map((url, idx) => (
              <div key={idx} style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleEvidenceToggle(url)}>
                <img
                  src={url}
                  alt={`Evidencia ${idx}`}
                  style={{
                    width: '100%',
                    height: '100px',
                    objectFit: 'cover',
                    borderRadius: 8,
                    border: selectedEvidence.includes(url) ? '3px solid #3b82f6' : '1px solid #ddd',
                    opacity: selectedEvidence.includes(url) ? 1 : 0.7
                  }}
                />
                {selectedEvidence.includes(url) && (
                  <div style={{
                    position: 'absolute', top: 5, right: 5,
                    background: '#3b82f6', color: 'white',
                    borderRadius: '50%', width: 20, height: 20,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.8rem', fontWeight: 'bold'
                  }}>✓</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>

        {/* SECCIÓN DE TAGS */}
        <div className="form-group">
          <label className="form-label">¿Qué destacó del servicio? (Opcional)</label>
          {/* ... Existing Tags Code ... */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px' }}>
            {AVAILABLE_TAGS.map(tag => (
              <button
                key={tag}
                type="button"
                onClick={() => toggleTag(tag)}
                style={{
                  padding: '8px 12px',
                  borderRadius: '20px',
                  border: '1px solid #ddd',
                  background: selectedTags.includes(tag) ? '#007bff' : '#f8f9fa',
                  color: selectedTags.includes(tag) ? '#fff' : '#333',
                  cursor: 'pointer',
                  fontSize: '0.9em',
                  transition: 'all 0.2s'
                }}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Cuéntanos tu experiencia</label>
          <textarea
            className="form-textarea"
            rows={4}
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
            placeholder="¿Fue puntual? ¿El trabajo quedó bien? ¿Lo recomendarías?"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Fotos Adicionales (Opcional)</label>
          <div className="file-input-wrapper">
            <input
              type="file"
              id="file-upload"
              className="form-input"
              multiple
              onChange={handleFileChange}
              accept="image/*"
              style={{ display: 'none' }}
            />
            <label htmlFor="file-upload" className="form-button secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
              <IoImageOutline /> Agregar Fotos
            </label>
            <span style={{ marginLeft: '10px' }}>{archivos.length} archivos</span>
          </div>
        </div>

        {previews.length > 0 && (
          <div className="gallery-container" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginTop: '10px' }}>
            {previews.map((previewUrl, index) => (
              <img key={index} src={previewUrl} alt="Vista previa" style={{ width: '100%', height: '80px', objectFit: 'cover', borderRadius: '8px' }} />
            ))}
          </div>
        )}

        <button type="submit" className="form-button" disabled={enviando} style={{ marginTop: '20px' }}>
          {enviando ? 'Enviando...' : 'Enviar Calificación'}
        </button>
      </form>
    </div>
  );
}

export default CalificarServicioScreen;
